import React, { memo, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import { SecondaryButton, TransitionModal } from '../../index';
import * as Constants from '../../../common/constants';
import { useMaster } from '../../../../model/hooks/index';
export const JobImageTemplate = memo((props) => {
    const { open, onClose, onClickSelect } = props;
    const { t } = useTranslation();
    const { master } = useMaster();
    const [templates, setTemplates] = useState([]);
    useEffect(() => {
        var _a, _b;
        if (!((_a = master) === null || _a === void 0 ? void 0 : _a.jobTemplateImages))
            return;
        const temp = (_b = master.jobTemplateImages) === null || _b === void 0 ? void 0 : _b.map((obj) => {
            return {
                file: obj,
                isSelected: false,
            };
        });
        setTemplates(temp);
    }, [master]);
    const onClickItem = (idx) => {
        const newTemplates = templates.map((obj) => {
            return { file: obj.file, isSelected: false };
        });
        newTemplates[idx].isSelected = true;
        setTemplates(newTemplates);
    };
    const _onClickSelect = () => {
        var _a;
        onClickSelect((_a = templates.filter((obj) => obj.isSelected)[0]) === null || _a === void 0 ? void 0 : _a.file);
    };
    return (React.createElement(TransitionModal, { isOpen: open, onClose: onClose },
        React.createElement(STitleArea, null,
            React.createElement(STitle, null, t('画像テンプレート')),
            React.createElement(SecondaryButton, { disabled: templates.filter((obj) => obj.isSelected).length === 0, onClick: _onClickSelect }, t('選択する'))),
        React.createElement(SContentArea, null,
            React.createElement(Grid, { container: true, spacing: 1 }, templates.map((obj, idx) => {
                return (React.createElement(Grid, { key: obj.file.url, item: true, xs: 12, md: 4 },
                    React.createElement(SAvatar, { src: obj.file.url, variant: "square", selected: obj.isSelected, onClick: () => onClickItem(idx) })));
            })))));
});
const STitleArea = styled.div `
  display: flex;
  justify-content: space-between;
`;
const STitle = styled.p `
  font-size: 20px;
  font-weight: bold;
  margin: 0;
`;
const SContentArea = styled.div `
  padding-top: 32px;
  padding-bottom: 32px;
`;
const SAvatar = styled(Avatar) `
  &&& {
    width: 100%;
    height: 300px;
    cursor: pointer;
    border: ${({ selected }) => selected && `2px solid ${Constants.COLOR.ORANGE700}`};
  }
`;
